import React from 'react';
import { useSelector } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import { NavCard } from 'dyl-components';
import { Link } from 'react-router-dom';

import SettingsHeader from 'shared/SettingsHeader';
import { SETTINGS_ROOT } from 'shared/constants/SETTINGS';
import RestrictedView from 'shared/RestrictedView';

const SettingsCategory = ({
    title,
    description,
    settings
}) => {
    const userAuthTimezone = useSelector((state) => state.auth.timezone);
    return (
        <React.Fragment>
            <SettingsHeader
                title={title}
                description={description}
            />
            <Grid columns={3}>
                {settings.map(({ icon, header, description, path, exclude, disabled, setTimestampParameters = () => { return ''; }, productPermission, userPermission }) => {
                    const queryParameters = setTimestampParameters(userAuthTimezone);
                    return (
                        !exclude && <RestrictedView type="hidden" productPermission={productPermission} userPermission={userPermission}>
                            <Grid.Column key={header}>
                                {!disabled ? 
                                    <Link style={{ color: 'inherit', textDecoration: 'inherit' }} to={`/${SETTINGS_ROOT}/${path}${queryParameters !== '' ? `?${queryParameters}` : ''}`} >
                                        <NavCard icon={icon} header={header} description={description} />
                                    </Link>
                                :
                                    <NavCard icon={icon} header={header} description={description} disabled={disabled} />
                                }
                            </Grid.Column>
                        </RestrictedView>
                    )
                })}
            </Grid>
        </React.Fragment>
    )
};

export default SettingsCategory;
